import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {AuthService} from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { ShoppingCartService } from 'src/app/amena/services/shopping-cart-service';

export const ENTREGA_SIM_TIENDA = 'tienda';
export const ENTREGA_SIM_LOGISTICA = 'logistica';

@Injectable({
    providedIn: 'root'
})

export class ApiAmenaService {
    private http: HttpClient;
    pdv: any;
    staircaseTypes: any;
    floorTypes: any;
    private datosTipoVia: any;
    private datosProvincias: any;
    private resultadosNotCustomer: any;
    private documentTypes: any;
    private resultadosCustomer: any;
    private migrationData: any;

    constructor(
        http: HttpClient, 
        private auth: AuthService,
        private shoppingCartService: ShoppingCartService
    ) {
        this.http = http;
        this.pdv = new BehaviorSubject<any>(null);
        this.staircaseTypes = new BehaviorSubject<any>(null);
        this.floorTypes = new BehaviorSubject<any>(null);
        this.datosTipoVia = new BehaviorSubject(null);
        this.datosProvincias = new BehaviorSubject(null);
        this.resultadosNotCustomer = new BehaviorSubject<any>(null);
        this.documentTypes = new BehaviorSubject<any>(null);
        this.resultadosNotCustomer = new BehaviorSubject<any>(null);
        this.resultadosCustomer = new BehaviorSubject<any>(null);
        this.migrationData = new BehaviorSubject<any>(null);       
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getCountries() {
        return this.http.get(environment.amenaEndpoint + 'master/countries', {headers: this.getHeaders()});
    }

    getCustomerInfoFromService(customerInfo) {
        return this.http.post(environment.amenaEndpoint + 'customer/info', customerInfo, {headers: this.getHeaders()});
    }

    setPDV(pdv: any) {
        this.pdv.next(pdv);
    }

    getPDV() {
        return this.pdv.asObservable();
    }

    getStaircaseTypesFromService() {
        return this.http.get(environment.amenaEndpoint + 'master/staircase-types', {headers: this.getHeaders()});
    }

    setStaircaseTypes(data) {
        this.staircaseTypes.next(data);
    }

    getStaircaseTypes() {
        return this.staircaseTypes.asObservable();
    }

    getFloorTypesFromService() {
        return this.http.get(environment.amenaEndpoint + 'master/floor-types', {headers: this.getHeaders()});
    }

    getDocumentTypesFromService() {
        return this.http.get(environment.amenaEndpoint + 'master/document-types', {headers: this.getHeaders()});
    }

    setFloorTypes(data) {
        this.floorTypes.next(data);
    }

    getFloorTypes() {
        return this.floorTypes.asObservable();
    }

    setDatosTipoVia(data) {
        this.datosTipoVia.next(data);
        this.shoppingCartService.getShoppingCart().getOperation().setDatosVia(data);
    }

    getDatosTipoVia() {
        return this.datosTipoVia.asObservable();
    }

    setProvincias(data) {
        this.datosProvincias.next(data);
    }

    getProvincias() {
        return this.datosProvincias.asObservable();
    }

    // Customer
    setDataFromCustomer(data) {
        this.resultadosCustomer.next(data);
    }

    getDataFromCustomer() {
        return this.resultadosCustomer.asObservable();
    }

    setDataFromNotCustomer(data) {
        this.resultadosNotCustomer.next(data);
    }

    getDataFromNotCustomer() {
        return this.resultadosNotCustomer.asObservable();
    }

    setDocumentTypes(data) {
        this.documentTypes.next(data);
    }

    getDocumentTypes() {
        return this.documentTypes.asObservable();
    }

    setMigrationData(data) {
        this.migrationData.next(data);
    }

    getMigrationData() {
        return this.migrationData.asObservable();
    }

    createOrder(order) {
        return this.http.post(environment.amenaEndpoint + 'order/create', order, {headers: this.getHeaders()});
    }
}
